var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoutteVerte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.52 165.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2ee84d;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#eaeaea;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m115.75,80.74c-3.04-8.52-7.25-16.52-11.91-24.26-11.81-19.59-26.12-37.26-41.6-54.03-1.13-1.23-1.73-.97-2.72.1-13.58,14.7-26.29,30.09-37.13,46.94-8.6,13.37-16.24,27.2-19.87,42.92-1.8,7.77-1.67,15.51-.15,23.23,1.43,7.28,4.31,14.05,8.33,20.31,7.93,12.34,19.06,20.61,32.92,25.05,6.78,2.17,13.83,3,21.04,2.35,5.74-.52,11.33-1.57,16.75-3.53,22.88-8.27,39.03-30.34,38.94-56.14.49-7.53-1.87-15.29-4.6-22.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.99,104.09c-20.99-13.66-47.46-9.14-61.59-4.6-.58,5.66-.25,11.31.85,16.94,1.43,7.28,4.31,14.05,8.33,20.31,7.93,12.34,19.06,20.61,32.92,25.05,6.78,2.17,13.83,3,21.04,2.35,5.74-.52,11.33-1.57,16.75-3.53,22.88-8.27,39.13-30.35,39.04-56.15.02-.52.05-.99.05-1.49-17.4,12.62-40.52,12.1-57.39,1.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoutteVerte);
export default __webpack_public_path__ + "static/media/goutte_verte.bfbe403a51940e78b60172b1477310da.svg";
export { ForwardRef as ReactComponent };